export enum HealthNutritionTypes {
  Standart = "estandar",
  Vegetarian = "vegetariana",
  Vegan = "vegana",
  DairyFree = "Sinlacteos",
  GlutenFree = "Singluten",
  FishFree = "Sinpescado",
}
